rs.module("layouts/anonymous",

    ["controls/diagnostics/debugpane", "controls/diagnostics/scriptlog"],

    function (debugPane, scriptLog) {

        // Initialize the menu
        function initialize(jsSelectors, cssClasses) {

            var debugToggle = $.js(jsSelectors.debugToggle, { required: false });

            // toggle the debug button state based on whether the debug pane is open
            debugToggle.toggleClass(cssClasses.toggled, debugPane.visible);

            // toggle debug pane when debug toggle is clicked
            debugToggle.click(function () {

                debugPane.visible = !debugPane.visible;

                $(this).toggleClass(cssClasses.toggled, debugPane.visible);
            });

            // Listen for javascript errors to display an indicator
            scriptLog.onJsError(function () {
                // Show the indicator, select with required:false because of Production mode
                $.js(jsSelectors.debugAlert, { required: false }).removeClass(cssClasses.hidden);
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);